if (!customElements.get('support-toggle')) {
  class SupportToggle extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!this.hasAttribute('open')) {
        this.removeAttribute('open');
        document
          .querySelector(`support-modal.is-open`)
          ?.classList.remove('is-open');
        bodyScroll.clear();
      } else {
        this.setAttribute('open', true);
      }

      document.dispatchEvent(new CustomEvent(`${this.id}:toggle`));
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this), false);
    }
  }

  customElements.define('support-toggle', SupportToggle);
}
